import React from 'react'
import {
    Sheet,
    SheetContent,
    SheetDescription,
    SheetHeader,
    SheetTitle,
    SheetTrigger,
  } from "@/components/ui/sheet"
  import { CalendarRange } from "lucide-react";

  export function KeyDates() {
    // Static key dates data for static build
    const staticKeyDates = [
        { date: "2024-07-03", event: "Conference Start Date" },
        { date: "2024-07-07", event: "Conference End Date" },
        { date: "2024-02-15", event: "Early Bird Registration Deadline" },
        { date: "2023-12-01", event: "Abstract Submission Opens" },
        { date: "2024-03-15", event: "Abstract Submission Deadline" },
    ];

    return (
        <>
            <Sheet>
                <SheetTrigger className="fixed bottom-5 left-5 rounded-lg p-3 text-xl font-bold drop-shadow-lg hover:drop-shadow-xl flex items-center gap-2 uppercase bg-dbrown text-white z-50"><CalendarRange /><span className="hidden lg:block">Key Dates</span></SheetTrigger>
                <SheetContent side={"left"} className="overflow-y-auto h-screen">
                    <SheetHeader>
                        <SheetTitle className="mb-0 pb-0 text-dbrown text-2xl">Key Dates</SheetTitle>
                        <SheetDescription>
                        {staticKeyDates.map((item, index) => (
                            <div key={index} className="border-b py-2">
                                <h3 className="text-lg pt-1 mb-0">{item.event}</h3>
                                <p className="text-base font-semibold text-black mb-0">{item.date}</p>
                            </div>
                        ))}
                        </SheetDescription>
                    </SheetHeader>
                </SheetContent>
            </Sheet>
        </>
    )
}


export function KeyDatesBar() {
    // Static key dates data for static build
    const staticKeyDates = [
        { date: "2024-07-03", event: "Conference Start Date" },
        { date: "2024-07-07", event: "Conference End Date" },
        { date: "2024-02-15", event: "Early Bird Registration Deadline" },
        { date: "2023-12-01", event: "Abstract Submission Opens" },
        { date: "2024-03-15", event: "Abstract Submission Deadline" },
    ];

    return (
        <>
            {staticKeyDates.map((item, index) => (
                <div key={index} className="border-b border-lorange py-6 px-5">
                    <h3 className="text-lg pt-1 mb-0 text-ivory">{item.event}</h3>
                    <p className="text-base font-semibold text-white/80 mb-0">{item.date}</p>
                </div>
            ))}
        </>
      )
}